import { inEnum, isBoolean, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";

export enum YM_Category  {
    Politica="Politica",
    Cronaca="Cronaca",
    Spettacolo="Spettacolo",
    Sport="Sport",
    Tecnologia="Tecnologia",
    Motori="Motori",
    Viaggi="Viaggi",
    Scienze="Scienze",
    Design="Design",
    Donna="Donna",
    Rugby="Rugby",
    Musica="Musica",
    Cucina="Cucina"
}


export interface MediaMetaData {

    category: YM_Category,
    channelName: string,
    channelUrl: string,
    hot: boolean,
    duration: number,
    publish_stamp: number,
    storyTitle?: string
}


export function isMediaMetaData(a: any): a is MediaMetaData {
 
    return isObject(a) &&
            ("category" in a && inEnum(a.category, YM_Category)) &&
            ("channelName" in a && isString(a.channelName)) && 
            ("channelUrl" in a && isString(a.channelUrl)) &&
            ("hot" in a && isBoolean(a.hot)) &&
            (!("storyTitle" in a) || isString(a.storyTitle));

}

